import { ManifestApiResponse } from '@manifest-cyber/types/interface/apiResponse';
import { useQuery } from '@tanstack/react-query';
import { AxiosProxy } from '../../api/axiosProxy/axiosProxy';

interface Params {
  userId?: string;
  memberId?: string;
}

interface Options {
  staleTime?: number;
}

export interface OrganizationMember {
  emails: string[];
  firstName: string;
  lastName: string;
  userId: string;
  id: string;
}
export interface MappedOrganizationMember {
  email: string;
  firstName?: string;
  lastName?: string;
  displayName: string;
  userId: string;
  id: string;
}

export const useFetchOrganizationMember = ({
  userId: targetUserId,
  memberId,
}: Params) => {
  const fetchUrl = `member${memberId ? `/${memberId}` : ''}`;

  return useQuery({
    enabled: !!targetUserId,
    queryKey: ['member', { _id: targetUserId }, `/${fetchUrl}`],
    queryFn: async (): Promise<MappedOrganizationMember> => {
      const response: ManifestApiResponse<OrganizationMember> = await AxiosProxy.get({
        url: fetchUrl,
        params: { targetUserId: targetUserId },
      });

      if (!response.data) {
        throw new Error('No data returned from API');
      }

      const { firstName, lastName, emails, userId, id } = response.data;
      const email = emails[0] || '';
      return {
        email,
        firstName,
        lastName,
        displayName: firstName && lastName ? `${firstName} ${lastName}`.trim() : email,
        userId,
        id,
      };
    },
    staleTime: 1000 * 60 * 15, // 15 minutes
  });
};
